import { useEffect, useState } from "react";
import cityView from "../../assest/GreenHome/images/CityView.png";
import cityViewSmallScreen from "../../assest/GreenHome/images/CityViewSmallScreen.png";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { delayNavigation } from "../../helpers/helpers";

const HerroSectionAboutUs = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [scrollY, setScrollY] = useState(0);
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY); // Capture the vertical scroll position
    };

    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 950);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    // Initial check
    handleResize();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="bg-black relative h-screen w-screen overflow-hidden text-white">
      <img
        src={isLargeScreen ? cityView : cityViewSmallScreen}
        alt="K2 invest green Home banner"
        className="opacity-90 inline-block max-w-full w-full h-[120vh] text-center align-middle object-cover"
        style={{
          transform: `translateY(-${scrollY * 0.1}px)`,
          transition: "transform 1s",
        }}
      />

      <div className="absolute flex flex-col justify-start items-start max-w-[600px] z-20 bottom-0 top-2/3 left-6 xl:left-24 xl:top-3/4 h-fit">
        <div className=" text-primary-light font-gilroy text-3xl xl:text-6xl leading-tight mb-0 mt-0 tracking-widest uppercase ">
          K2 Invest
        </div>
        <a
          href="/projects/greenhome/apartments"
          onClick={(event) => {
            delayNavigation(
              dispatch,
              navigate,
              "/projects/greenhome/apartments",
              event
            );
          }}
          className="relative text-primary-light uppercase text-lg font-bold tracking-wider  bg-transparent no-underline opacity-100 transform transition-all duration-[0.45s] ease-out delay-[0.6s] flex flex-col justify-center items-center whitespace-nowrap cursor-pointer group"
        >
          გაიგე მეტი ...
          <span className="absolute bottom-0 left-0 w-0 h-[2px] bg-primary-light transition-all duration-500 group-hover:w-full"></span>
        </a>
      </div>
    </div>
  );
};

export default HerroSectionAboutUs;
